import { useState } from "react";
import { Alert, Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ConflictError } from "../../errors/http_errors";
import { User } from "../../models/user";
import * as UserApi from "../../network/user_api";
import { SignUpCredentials } from "../../network/user_api";
import styles from "./Modal.module.scss";
import TextInputField from "../FormFields/TextInputField";
import ActionButton from "../Buttons/Action/ActionButton";
import Divider from "../Decors/Divider/Divider";
import CloseButton from "../Buttons/Close/CloseButton";
interface SignUpModalProps {
  onDismiss: () => void;
  onSignUpSuccessful: (user: User) => void;
}

const SignUpModal = ({ onDismiss, onSignUpSuccessful }: SignUpModalProps) => {
  const [errorText, setErrorText] = useState<string | null>(null);
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<SignUpCredentials>();

  async function onSubmit(credentials: SignUpCredentials) {
    try {
      const newUser = await UserApi.signUp(credentials);
      onSignUpSuccessful(newUser);
    } catch (error) {
      if (error instanceof ConflictError) {
        setErrorText(error.message);
      } else {
        alert(error);
      }
      console.error(error);
    }
  }

  return (
    <Modal dialogClassName={styles.modalWindow} show onHide={onDismiss}>
      <Modal.Header className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>
          {t("common.signup")}
        </Modal.Title>
      <CloseButton onDismiss={onDismiss} />
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <div className={styles.smallDivider}>
          <Divider />
        </div>
        {errorText && <Alert variant="danger">{errorText}</Alert>}
        <Form onSubmit={handleSubmit(onSubmit)}>
          <TextInputField
            name="firstName"
            label={t("common.firstName")}
            type="text"
            placeholder="Jane"
            register={register}
            registerOptions={{ required: "Required" }}
            error={errors.firstName}
          />
          <TextInputField
            name="lastName"
            label={t("common.lastName")}
            type="text"
            placeholder="Doe"
            register={register}
            registerOptions={{ required: "Required" }}
            error={errors.lastName}
          />
          <TextInputField
            name="email"
            label={t("common.email")}
            type="email"
            placeholder="example@mail.com"
            register={register}
            registerOptions={{ required: "Required" }}
            error={errors.email}
          />
          <TextInputField
            name="userName"
            label={t("common.username")}
            type="text"
            placeholder="janedoe"
            register={register}
            registerOptions={{ required: "Required" }}
            error={errors.userName}
          />
          <TextInputField
            name="password"
            label={t("common.password")}
            type="password"
            placeholder="Password"
            register={register}
            registerOptions={{ required: "Required" }}
            error={errors.password}
          />
          <div className={styles.modalButtonContainer}>
            <ActionButton
              className={styles.modalButton}
              type="submit"
              disabled={isSubmitting}
            >
              {t("common.signup")}
            </ActionButton>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer className={styles.modalBody} />
    </Modal>
  );
};

export default SignUpModal;
